import { render, staticRenderFns } from "./RelatorioAtendimentosMedicoAprovador.vue?vue&type=template&id=11a2287e"
import script from "./RelatorioAtendimentosMedicoAprovador.vue?vue&type=script&lang=js"
export * from "./RelatorioAtendimentosMedicoAprovador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports